export const SET_SINGLE_AUTH_OF_USER = 'SET_SINGLE_AUTH_OF_USER'
export const DO_SOMETHING = 'DO_SOMETHING'

let namespaceMember = 'member/';

export const SET_GENERAL_MEMBER_INFORMATION = namespaceMember + 'SET_GENERAL_MEMBER_INFORMATION';
export const SET_LOCATIONS_OF_MEMBER = namespaceMember + 'SET_LOCATIONS_OF_MEMBER';

export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/mutation-types.ts